




















































import { Vue, Component, Prop } from "vue-property-decorator";
import AnxTableContainer from "../AnxTableContainer/AnxTableContainer.vue";
import AnxTableRow from "../AnxTableRow/AnxTableRow.vue";
import AnxTableCol from "../AnxTableCol/AnxTableCol.vue";

/**
 * A powerfull table with many design features
 */
@Component({
  components: {
    AnxTableContainer,
    AnxTableRow,
    AnxTableCol
  }
})
export default class AnxTable extends Vue {
  /** Whether the table should be scrollable or not */
  @Prop({ default: null }) scrollable!: boolean | null;

  /** Whether the table is stripped or not */
  @Prop({ default: null }) stripped!: boolean | null;

  /** Wheter the tables outline is bordered or not */
  @Prop({ default: null }) bordered!: boolean | null;

  /** Do not show any borders */
  @Prop({ default: null }) borderless!: boolean | null;

  /** Wheter the table is bordered or not */
  @Prop({ default: null }) hover!: boolean | null;

  /** Wheter the table is bordered or not */
  @Prop({ default: null }) height!: string | null;

  /** Whether to display the header columns in uppercase or not */
  @Prop({ default: null }) uppercaseTitle!: boolean | null;

  /** The items for the table */
  @Prop({ default: null }) items!: Array<object> | null;

  /** With this property, the names for the columns and the linked index of the items can be defined */
  @Prop({ default: null }) columns!:
    | {
        name: string;
        index: string;
        width: string | null;
        align: string | null;
      }[]
    | null;

  /** Remove the header of the table */
  @Prop({ default: null }) noHeader!: boolean | null;

  /** Converts camelCase to Text */
  private camelCaseToText(camelCase: string) {
    return camelCase.replace(/([A-Z])/g, " $1").replace(/^./, function(str) {
      return str.toUpperCase();
    });
  }

  /** Returns the colums that should be displayed */
  private get displayColumns() {
    let columns: {
      name: string;
      index: string;
      width: string | null;
      align: string | null;
    }[] = [];

    if (this.columns === null) {
      /** If no specific columns are defined, we use the first entry of the items to get the names of the columns */
      if (this.items && this.items.length > 0) {
        for (const key of Object.keys(this.items[0])) {
          columns.push({
            name: this.camelCaseToText(key),
            index: key,
            width: "auto",
            align: "left"
          });
        }
      }
    } else {
      /** If the columns property is defined, we use it for the names */
      columns = this.columns;
    }

    return columns;
  }
}
